<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title" v-for="(header, index) in headers" :key="index">{{header | capitalize}}</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
          <tr v-for="(item, index) in itemList" :key="index" class="content">
            <td class="item">
              <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
              <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
              <div class="stack">
                <span class="title">{{item.location_name}}</span>
                <span class="location" v-if="item.category === 'AR' && item.airport">
                  {{item.airport.airport_name}} . {{item.city_name}}
                </span>
                <span class="location" v-else>
                  {{item.property_type_display}} . {{item.city_name}}
                </span>
                <span class="price-mobile">{{item.price | formatMoney}}</span>
              </div>
            </td>
            <td class="placement none"><span>{{item.placement}}</span></td>
            <td v-if="item.is_audience_displayed" class="visitor none"><span>{{item.audience_daily}} people</span></td>
            <td v-else class="visitor none">-</td>
            <td class="price none"><span> {{item.price | formatMoney}} </span></td>
            <td class="icon-list" @click.stop="removeItem(item)">
              <adx-loading-secondary v-if="isLoading.includes(item.id)" />
              <i v-if="!isLoading.includes(item.id)" class="adx-ic_close"></i>
            </td>
          </tr>
          <tr v-if="isShowMore" @click="isShowMore = false; allShown = true;">
            <td colspan="5" class="show-more"> <span> Show More </span> </td>
          </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import LoadingSecondary from '@/components/Loading/Secondary'

import api from '@/api/'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-list-view',
  components: {
    'menu-expansion': MenuExpansion,
    'adx-loading-secondary': LoadingSecondary
  },
  props: {
    items: {
      required: false
    },
    category: {
      required: false
    },
  },
  data() {
    return {
      isShowMore: false,
      allShown: false,
      headers: [
      'items',
      'placement',
      'daily visitor',
      'price / day'
      ],
      isLoading: []
    }
  },
  computed: {
    itemList() {
      if (this.items.length > 10 && !this.allShown) {
        this.isShowMore = true
        return this.items.slice(0, 10)
      }
      return this.items
    }
  },
  methods: {
    removeItem(item) {
      let category = this.category

      const devices = ['lifestyle', 'malls', 'spbu', 'airport']
      if (devices.includes(category)) {
        category = 'idooh'
      }

      let data = {
          'channel_id': item.id,
          'channel_name': category
      };
      (async () => {
        this.isLoading.push(item.id)

        const response = await api.patch(apiV2.campaignRemoveListing(this.$route.params.id), data, { needToken: true })
        this.$emit('reloadData', this.category, item.id)
        this.isLoading = []
      })();
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>